const triggerChat = ref(false)

export function useChat() {
  return {
    triggerChat,
  }
}
